module.exports = __webpack_public_path__ + "assets/microsoft-sign-in.a59541f6.svg";